@use '@/styles/tokens' as *;
@use '@/styles/popup' as *;

.select {
  min-width: 0;

  :global(.ant-select-selector) {
    border-radius: 10px;
  }

  &:hover:not(:global(.ant-select-disabled)) :global(.ant-select-selector) {
    box-shadow: var(--shadow-field-hover);
  }

  :global(.ant-select-selection-placeholder) {
    color: var(--overlay-20);
  }
}

.compact :global(.ant-select-selector) {
  height: 36px;
}

.tag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 18px;
  margin-inline-end: 6px;
  padding: 0 8px;
  border-radius: 24px;
  background: $color-neutral-100;
  font-size: 12px;
  color: var(--text-primary);
  white-space: nowrap;
}

.tagLabel {
  line-height: 1;
}

.tagRemove {
  display: inline-flex;
  align-items: center;
  padding: 0;
  border: none;
  background: none;
  color: var(--text-primary);
  cursor: pointer;
}

.popup {
  @include popup-chrome;

  :global(.ant-select-item-option) {
    @include popup-item;
  }

  :global(.ant-select-item-option-selected) {
    background: $color-neutral-100;
  }
}
